var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 88,
    height: 88,
    rx: 44,
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2627 48.2177C29.0743 46.2371 29.0743 43.7629 30.2627 41.7823V41.7823C30.6253 41.1779 31.2261 40.7545 31.9172 40.6163L34.7389 40.052C34.907 40.0183 35.0586 39.9282 35.1683 39.7965L40.5029 33.395C41.6854 31.9759 42.2767 31.2664 42.8044 31.4574C43.332 31.6485 43.332 32.5721 43.332 34.4193L43.332 55.5807C43.332 57.4279 43.332 58.3515 42.8044 58.5426C42.2767 58.7336 41.6854 58.0241 40.5029 56.605L35.1683 50.2035C35.0586 50.0718 34.907 49.9817 34.7389 49.948L31.9172 49.3837C31.2261 49.2455 30.6253 48.8221 30.2627 48.2177V48.2177Z",
    stroke: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8939 39.1075C52.4486 40.6622 53.3259 42.7684 53.3346 44.9672C53.3432 47.1659 52.4826 49.279 50.9401 50.846",
    stroke: "#CCCCCC",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0459 36.1005C60.5647 38.7125 61.9859 42.251 61.9999 45.9448C62.0139 49.6387 60.6196 53.1887 58.1209 55.8212",
    stroke: "#CCCCCC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.8b4f3a6b079fccd6b184a8084255a1bd.svg";
export { ForwardRef as ReactComponent };